import pptxgen from "pptxgenjs";
import { downloadFilenameGeneratorForPPT } from ".";
import {
    RESPONSE_TYPE,
    IContent,
    RESPONSE_BY,
} from "../../../models/IQueryType";

import LABELS from '../../../ui-constants/en.json';
import { decodeHTML, } from "../../../utils/commonUtils";



export enum BulletPointType {
    hyphen = '-',
    dot = '•',
    number = 'number',
    NA = "NA"
}

export const exportBYODToPPT = (
    userQueryWithResponse: any,
) => {
    let pres = new pptxgen();
    let rows: pptxgen.TableRow[] = [];

    const { query, response, } = userQueryWithResponse;

    const handleCsvFormat = (data: string) => {
        try {
            return data
                .replaceAll("---|", "")
                .replaceAll("--", "")
                .replaceAll(/\s{3,}/g, "")
                .replaceAll("|", ",")
                .replaceAll(",\n,", ",\n")
                .replaceAll(",\n-", "\n")
                .replaceAll("\n\n", "\n")
                .trim();
        } catch (err) {
            return "";
        }
    };


    const countSpacesBeforeHyphen = (input: string, bulletPointType: BulletPointType): number => {
        let indexOfHyphen = 0
        if (bulletPointType === BulletPointType.hyphen) {
            // indexOfHyphen = input.indexOf('-');
            const match = input.match(/^(\s*)-/);
            return match ? match[1].length : 0;
        }
        if (bulletPointType === BulletPointType.dot) {
            indexOfHyphen = input.indexOf('•');
        }

        if (bulletPointType === BulletPointType.number) {
            const match = input.match(/^(\s*)/); // Matches leading whitespace characters
            return match ? match[1].length : 0;
        }
        const substringBeforeHyphen = input.slice(0, indexOfHyphen);
        const spaceCount = (substringBeforeHyphen.match(/ /g) || []).length;
        return spaceCount;
    };

    const isNumericBullet = (sentence: string): boolean => {
        const numericBulletPattern = /^\s*\d+[\.\)\-]\s+/;
        return numericBulletPattern.test(sentence);
    };

    const handleRowCreation = (data: string, hasBulletpoint: boolean, isBold: boolean, indentLevel: number, isExtraSpace: boolean): pptxgen.TextProps[] => {
        let dynamicTextArray: pptxgen.TextProps[] = [];
        if (hasBulletpoint) {
            dynamicTextArray.push({
                text: '.',
                options: {
                    fontSize: 10,
                    bold: isBold,
                    indentLevel: indentLevel,
                    bullet: true,
                    align: "left",
                    color: "FFFFFF",
                },
            });
            dynamicTextArray.push({
                text: data,
                options: {
                    fontSize: 10,
                    bold: isBold,
                    italic: false,
                },
            });
        }
        else {
            if (!isExtraSpace) {
                dynamicTextArray.push({
                    text: '.',
                    options: {
                        fontSize: 10,
                        bold: isBold,
                        italic: false,
                        color: "FFFFFF",
                    },
                });
            }
            dynamicTextArray.push({
                text: data,
                options: {
                    fontSize: 10,
                    bold: isBold,
                    italic: false,
                },
            });
        }
        return dynamicTextArray;
    }

    try {
        const userQuery = query && decodeHTML(query);
        const SEChatSummary = response && handleCsvFormat(response);

        const rawSESummary = response


        const headerPattern1 = /^#\s+(.+)$/gm;
        const headerPattern2 = /^##\s+(.+)$/gm;
        const headerPattern3 = /^###\s+(.+)$/gm;
        const headerPattern4 = /^####\s+(.+)$/gm;
        const headerPattern5 = /^#####\s+(.+)$/gm;
        const boldPattern = /\*\*(.+?)\*\*/g;
        let prevIntendLevel = 0;
        const splitlines = rawSESummary?.split('\n');
        for (let i = 0; i < splitlines.length; i++) {
            let line = splitlines[i];
            let formattedLine = line; // 
            if (headerPattern1.test(line)) {
                line = line.replace('#', '');
                rows.push([{ text: line, options: { bold: true, color: '656579' } }]);

            }
            // Check and apply header pattern 2
            else if (headerPattern2.test(line)) {
                line = line.replace('##', '');
                rows.push([{ text: line, options: { bold: true, color: '656579' } }]);
            }
            // Check and apply header pattern 3
            else if (headerPattern3.test(line)) {
                line = line.replace('###', '');
                rows.push([{ text: line, options: { bold: true, color: '656579' } }]);
            }
            // Check and apply header pattern 4
            else if (headerPattern4.test(line)) {
                line = line.replace('####', '');
                rows.push([{ text: line, options: { bold: true, color: '656579' } }]);
            }
            // Check and apply header pattern 5
            else if (headerPattern5.test(line)) {
                line = line.replace('#####', '');
                rows.push([{ text: line, options: { bold: true, color: '656579' } }]);
            }
            else {
                if (line.trim().length > 0) {
                    let currentIndentLevel = 0;
                    let isNumericbulletpoint = isNumericBullet(line);
                    let startsWithHyphen = line.trim().startsWith('-');
                    if (isNumericbulletpoint) {
                        currentIndentLevel = countSpacesBeforeHyphen(line, BulletPointType.number);

                    }
                    else {
                        currentIndentLevel = countSpacesBeforeHyphen(line, BulletPointType.hyphen);
                    }

                    currentIndentLevel = currentIndentLevel > 0 ? currentIndentLevel - 1 : 0;


                    line = line.replace(/^\s*-/, "• ");
                    const updatedText = line.replace(/\*\*(.*?)\*\*/g, "**[Bold]$1[/Bold]**");
                    const splitText = updatedText.split(/\*\*/);
                    for (let i = splitText.length - 1; i >= 0; i--) {
                        if (splitText[i].trim() === "•") {
                            splitText.splice(i, 1); // Remove that specific element
                        }
                    }

                    let dynamicTextArray: pptxgen.TextProps[] = [];
                    for (let j = 0; j < splitText.length; j++) {
                        const isBold = splitText[j].includes("[Bold]");

                        if (isNumericBullet(splitText[1])) {
                            splitText[j + 1].replace("[Bold]", "[Bold]" + splitText[1])
                        }
                        else {
                            if (startsWithHyphen && isBold) {
                                splitText[j] = '• ' + splitText[j]
                            }

                            if (splitText[j].trim().length > 0) {
                                // Check if text contains [Bold]
                                let cleanedText = splitText[j].replace("[Bold]", "").replace("[/Bold]", " ");
                                let isExtraSpace = false
                                if (cleanedText == updatedText) {
                                    isExtraSpace = true
                                }

                                let textprops = handleRowCreation(cleanedText, isNumericbulletpoint ? isNumericbulletpoint : startsWithHyphen, isBold, currentIndentLevel, isExtraSpace)
                                // Check if textprops is an array and handle accordingly
                                if (Array.isArray(textprops)) {
                                    dynamicTextArray.push(...textprops); // Spread and push all elements
                                } else {
                                    dynamicTextArray.push(textprops); // Push single object
                                }
                            }
                            startsWithHyphen = false;
                            isNumericbulletpoint = false;
                        }
                    }
                    rows.push([{ text: dynamicTextArray }]);
                }
            }
        }

        const SESummaryRow: any = [
            [{ text: `${userQuery}`, options: { bold: true } }],
            [{ text: `${SEChatSummary}`, options: response?.responseType === "stop_generation" ? { color: '656579', italic: true } : {} }]
        ];

        if (response?.isParitallyAbortedResponse) {
            SESummaryRow.push([{ text: LABELS.chat_reply.PARTIAL_STOP_GENERATION_MSG, options: { color: '656579', italic: true } }]);
        }


        if (userQuery) {
            rows.unshift([{ text: `${userQuery}`, options: { bold: true, fontSize: 12, color: '000000' } }]);
            rows.unshift([{ text: "", options: {} }]); // Add an empty row for spacing
        }
        const maxRowsPerSlide = 12;
        const slidesRequired = Math.ceil(rows.length / maxRowsPerSlide); // Calculate the number of slides needed
        for (let i = 0; i < slidesRequired; i++) {
            const startRow = i * maxRowsPerSlide;
            const endRow = startRow + maxRowsPerSlide;
            const rowsToAdd = rows.slice(startRow, endRow);
            const dynamicHeight = rowsToAdd.length < maxRowsPerSlide ? (rowsToAdd.length / maxRowsPerSlide) * 8.5 : 8.6;
            pres.addSlide().addTable(rowsToAdd, { autoPage: false, h: dynamicHeight, rowH: 0.1, fontSize: 10 });
        }



        pres
            .write({ outputType: "blob" })
            .then((file) => {
                const link = document.createElement("a");
                link.href = window.URL.createObjectURL(file as Blob);
                link.download = downloadFilenameGeneratorForPPT(null, null, "UploadDoc&Query", "ppt");
                link.click();
            })
            .catch((err) => { });
    } catch (err) {
        console.log("::::PPT error", err);
    }
};